module.exports = __webpack_public_path__ + "img/486x486px-ed66.af11ffe8.png";